import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
import "dayjs/locale/de.js";

export default defineNuxtPlugin(() => {
  // eslint-disable-next-line import/no-named-as-default-member
  dayjs.locale("de");
  // eslint-disable-next-line import/no-named-as-default-member
  dayjs.extend(utc);
  return {
    provide: {
      dayjs,
      getMinuteHeight: (payload: {
        startHour: number;
        bookingStart?: Date;
        hoursToShow?: number;
      }) => {
        const { startHour, bookingStart, hoursToShow } = payload;
        const startTime = dayjs(bookingStart)
          .hour(startHour)
          .minute(0)
          .second(0);
        // INFO 9 hours is the default height of the calendar
        const DEFAULT_NUMBER_HOURS_TO_SHOW = hoursToShow ?? 9.0;
        const HOUR_HEIGHT = 100 / DEFAULT_NUMBER_HOURS_TO_SHOW;
        const MINUTES_IN_HOUR = 60;
        const ONE_MINUTE_HEIGHT = HOUR_HEIGHT / MINUTES_IN_HOUR;

        if (bookingStart) {
          const meetingStart = dayjs(bookingStart).utc().local();
          const diff = meetingStart.diff(startTime, "minute");
          // INFO Start at end of first element therefore add on hour height default
          return HOUR_HEIGHT + ONE_MINUTE_HEIGHT * diff;
        } else {
          const now = dayjs().utc().local();
          const diff = now.diff(startTime, "minute");
          // INFO Start at end of first element therefore add on hour height default
          return HOUR_HEIGHT + ONE_MINUTE_HEIGHT * diff;
        }
      },
    },
  };
});
